import { jsxs, jsx } from "react/jsx-runtime";
import { useGraphiQL, useGraphiQLActions } from "../provider.js";
import { Tooltip } from "../tooltip/index.js";
import { SettingsIcon } from "../../icons/index.js";
/* empty css          */
const ActivityRail = ({
  onPluginToggle,
  onSettingsClick
}) => {
  const plugins = useGraphiQL((state) => state.plugins);
  const visiblePlugin = useGraphiQL((state_0) => state_0.visiblePlugin);
  const {
    setVisiblePlugin
  } = useGraphiQLActions();
  return /* @__PURE__ */ jsxs("nav", { className: "graphiql-activity-rail", "aria-label": "Plugins", children: [
    /* @__PURE__ */ jsx("ul", { className: "graphiql-activity-rail-list", children: plugins.map((plugin) => {
      const Icon = plugin.icon;
      const isActive = (visiblePlugin == null ? void 0 : visiblePlugin.title) === plugin.title;
      const label = `${isActive ? "Hide" : "Show"} ${plugin.title}`;
      const nextPlugin = isActive ? null : plugin;
      return /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(Tooltip, { label, children: /* @__PURE__ */ jsx("button", { type: "button", className: `graphiql-activity-rail-item${isActive ? " active" : ""}`, "aria-pressed": isActive, "aria-label": label, onClick: () => {
        setVisiblePlugin(nextPlugin);
        onPluginToggle == null ? void 0 : onPluginToggle(nextPlugin);
      }, children: /* @__PURE__ */ jsx(Icon, { "aria-hidden": "true" }) }) }) }, plugin.title);
    }) }),
    /* @__PURE__ */ jsx("div", { className: "graphiql-activity-rail-spacer" }),
    onSettingsClick && /* @__PURE__ */ jsx(Tooltip, { label: "Settings", children: /* @__PURE__ */ jsx("button", { type: "button", className: "graphiql-activity-rail-settings", "aria-label": "Settings", onClick: onSettingsClick, children: /* @__PURE__ */ jsx(SettingsIcon, { "aria-hidden": "true" }) }) })
  ] });
};
export {
  ActivityRail
};
//# sourceMappingURL=index.js.map
